export default __webpack_public_path__ + "static/media/slider-img15.f8463b9f.jpg";